import React, { useEffect, useState } from "react";
import { Question } from "../../types";
import "./subjectiveQuestion.scss";

interface SubjectiveQuestionProps {
  question: Question;
  onAnswerChange?: (questionId: string, answer: string) => void;
  disabled?: boolean;
  questionNumber?: string;
}

const SubjectiveQuestion: React.FC<SubjectiveQuestionProps> = ({
  question,
  onAnswerChange,
  disabled = false,
  questionNumber = "1",
}) => {
  const [answer, setAnswer] = useState<string>("");

  useEffect(() => {
    // Initialize with existing answer if available
    if (
      question.answer &&
      Array.isArray(question.answer) &&
      question.answer.length > 0 &&
      question.answer[0].text
    ) {
      setAnswer(question.answer[0].text);
    } else if (typeof question.answer === "string") {
      setAnswer(question.answer);
    }
  }, [question.answer]);

  const handleAnswerChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setAnswer(value);
    if (onAnswerChange) {
      onAnswerChange(question.id, value);
    }
  };

  return (
    <div className="subjective-question--container">
      <div className="subjective-question--question text-sm">
        <span className="text-primaryBlue-1 mr-2 font-semibold">
          {questionNumber}.
        </span>
        {question.question}
        {question.required && <span className="required-asterisk">*</span>}
      </div>
      <div className="subjective-question--input-container">
        <textarea
          name={question.id}
          id={question.id}
          placeholder="Enter the information here"
          className="subjective-question--input h-20 w-full rounded border border-gray-300 p-2 text-tiny font-normal"
          onChange={handleAnswerChange}
          defaultValue={answer}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default SubjectiveQuestion;
